<template>
    <v-row>
      <v-col sm="4">
        <v-select
          class="mr-3 mt-5"
          :items="processTypes"
          item-value="value"
          item-text="label"
          :label="$t('monitoring.processes')"
          v-model="processType"
          item-color="primary"
        />
      </v-col>
      <v-col sm="4">
        <v-autocomplete
          class="mr-3 mt-5"
          :items="jobIdentifiers"
          :label="$t('keywords.id')"
          v-model="jobIdentifier"
        />
      </v-col>
      <v-col sm="4">
        <v-select
          class="mr-3 mt-5"
          :items="dates"
          :label="$t('monitoring.execution_date')"
          v-model="date"
        />
      </v-col>
    </v-row>
</template>
<script>
import Service from '../../../../services/MonitoringLegacyService'
import Utils from '../../utils'

export default {
  name: 'MonitoringFilters',

  data: () => ({
    jobIdentifiers: [],
    dates: [],
    listMaster: []
  }),

  computed: {
    processTypes () {
      return [
        { label: this.$t('keywords.api_query'), value: 'consultaapi' },
        { label: this.$t('keywords.send_data.rest'), value: 'jobenviadadosrest' },
        { label: this.$t('keywords.send_data.rest'), value: 'jobenviadadossoap' },
        { label: this.$t('keywords.rest_to_soap'), value: 'resttosoap' },
        { label: this.$t('keywords.workflow'), value: 'workflow' }
      ]
    },
    processType: {
      get () { return this.$route.query.processType },
      set (processType) {
        this.jobIdentifiers = []
        this.dates = []
        this.$router.replace({ query: { processType } })
      }
    },
    jobIdentifier: {
      get () { return this.$route.query.jobIdentifier },
      set (jobIdentifier) {
        const { processType, $router } = this
        this.dates = []
        $router.replace({ query: { processType, jobIdentifier } })
      }
    },
    date: {
      get () { return this.$route.query.date },
      set (date) {
        const { processType, jobIdentifier, $router } = this
        $router.replace({ query: { processType, jobIdentifier, date } })
      }
    }
  },

  watch: {
    processType: {
      immediate: true,
      handler () { this.processType && this.changeProcessType() }
    },
    jobIdentifier: {
      immediate: true,
      handler () { this.jobIdentifier && this.changeJobIdentifier() }
    },
    date: {
      immediate: true,
      handler () { this.date && this.changeDate() }
    }
  },

  methods: {
    removeDataView () {
      this.$emit('removeDataView')
    },
    changeProcessType () {
      this.removeDataView()
      Service.findAllJobIdentifiers(this.processType)
        .then(({ data }) => { this.jobIdentifiers = data })
    },
    changeJobIdentifier () {
      const { processType, jobIdentifier } = this
      this.removeDataView()
      Service.findAllDates(processType, jobIdentifier)
        .then(({ data }) => {
          this.dates = data
            .sort?.((a, b) => b - a)
            .map?.(value => ({ value, text: Utils.formatDate(value) }))
        })
    },
    changeDate () {
      this.removeDataView()
      this.$emit('findTableData', 1, 0)
    }
  }
}
</script>
